export const rootSelector = {
    deploy(state) {
        return state.deploy;
    }
}